(() => {
    window.LPMPreviewProfiles = window.LPMPreviewProfiles || {};
    const collierCordonDesktopSlots = {
  1: [
    { x: 246, y: 426, r: 0 }
  ],
  2: [
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 }
  ],
  3: [
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 }
  ],
  4: [
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 }
  ],
  5: [
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 }
  ],
  6: [
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 }
  ],
  7: [
     { x: 62, y: 270, r: 40 },
     { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 }
  ],
  8: [
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 }
  ],
  9: [
    { x: 28, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 460, y: 200, r: -52 }
  ],
  10: [
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 }
  ],
  11: [
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 }
  ],
  12: [
    { x: 7, y: 45, r: 80 },
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
   { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 },
    { x: 478, y: 45, r: -80 }
  ],
  13: [
   { x: 7, y: 45, r: 80 },
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 },
    { x: 478, y: 45, r: -80 }
  ]
};

const collierCordonMobileSlots = {
  1: [
    { x: 107, y: 270, r: 0 }
  ],
  2: [
    { x: 65, y: 254, r: 5 },
    { x: 148, y: 251, r: -10 }
  ],
  3: [
    { x: 40, y: 250, r: 30 },
    { x: 107, y: 270, r: 0 },
    { x: 178, y: 239, r: -40 }
  ],
  4: [
    { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 }
  ],
  5: [
    { x: 0, y: 207, r: 45 },
    { x: 40, y: 250, r: 30 },
    { x: 107, y: 270, r: 0 },
    { x: 178, y: 239, r: -40 },
    { x: 211, y: 196, r: -50 }
  ],
  6: [
    { x: -32, y: 152, r: 60 },
    { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 }
  ],
  7: [
    { x: -32, y: 152, r: 60 },
    { x: 0, y: 207, r: 45 },
    { x: 40, y: 250, r: 30 },
    { x: 107, y: 270, r: 0 },
    { x: 178, y: 239, r: -40 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 }
  ],
  8: [
    { x: -48, y: 105, r: 70 },
    { x: -32, y: 154, r: 60 },
     { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 },
    { x: 257, y: 100, r: -70 }
  ],
  9: [
    { x: -48, y: 105, r: 70 },
    { x: -32, y: 154, r: 60 },
     { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 107, y: 270, r: 0 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 },
    { x: 257, y: 100, r: -70 }
  ],
  10: [
    { x: -57, y: 50, r: 90 },
    { x: -47, y: 100, r: 70 },
    { x: -32, y: 154, r: 60 },
     { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 },
    { x: 257, y: 100, r: -70 },
    { x: 265, y: 48, r: -90 }
  ],
  11: [
    { x: -55, y: 50, r: 90 },
    { x: -47, y: 100, r: 70 },
    { x: -32, y: 154, r: 60 },
     { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 107, y: 270, r: 0 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 },
    { x: 257, y: 100, r: -70 },
    { x: 265, y: 48, r: -90 }
  ],
  12: [
    { x: -48, y: -20, r: 120 },
    { x: -60, y: 40, r: 100 },
    { x: -47, y: 100, r: 70 },
    { x: -32, y: 154, r: 60 },
     { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 },
    { x: 257, y: 100, r: -70 },
    { x: 265, y: 40, r: -100 },
    { x: 258, y: -20, r: -120 }
  ],
  13: [
    { x: -48, y: -20, r: 120 },
    { x: -60, y: 40, r: 100 },
    { x: -47, y: 100, r: 70 },
    { x: -32, y: 154, r: 60 },
     { x: 0, y: 207, r: 45 },
    { x: 53, y: 253, r: 15 },
    { x: 107, y: 270, r: 0 },
    { x: 156, y: 249, r: -15 },
    { x: 211, y: 196, r: -50 },
    { x: 238, y: 150, r: -60 },
    { x: 257, y: 100, r: -70 },
    { x: 265, y: 40, r: -100 },
    { x: 258, y: -20, r: -120 }
  ]
};
window.LPMPreviewProfiles["collier-cordon"] = {
  desktop: collierCordonDesktopSlots,
  mobile: collierCordonMobileSlots,
  charmWidthDesktop: 155,
  charmWidthMobile: 120,
  mobileBreakpoint: 749
};


const collierCordonPendentifDesktopSlots = {
 
  
  2: [
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 }
  ],
  3: [
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 }
  ],
  4: [
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 }
  ],
  5: [
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 }
  ],
  6: [
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 }
  ],
  7: [
     { x: 62, y: 270, r: 40 },
     { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 }
  ],
  8: [
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 }
  ],
  9: [
    { x: 28, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 460, y: 200, r: -52 }
  ],
  10: [
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 }
  ],
  11: [
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
     { x: 246, y: 426, r: 0 },
    { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 }
  ],
  12: [
    { x: 7, y: 45, r: 80 },
    { x: 7, y: 114, r: 65 },
    { x: 30, y: 200, r: 52 },
    { x: 62, y: 270, r: 40 },
    { x: 110, y: 341, r: 30 },
    { x: 184, y: 402, r: 5 },
   { x: 314, y: 395, r: -5 },
    { x: 375, y: 341, r: -30 },
    { x: 428, y: 270, r: -40 },
    { x: 458, y: 200, r: -52 },
    { x: 480, y: 114, r: -65 },
    { x: 478, y: 45, r: -80 }
  ]
};

const collierCordonPendentifMobileSlots = {

2: [
  { x: 76, y: 254, r: 5 },
  { x: 156, y: 251, r: -10 }
],

3: [
  { x: 55, y: 251, r: 30 },
  { x: 117, y: 270, r: 0 },
  { x: 182, y: 241, r: -40 }
],

4: [
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 }
],

5: [
  { x: 17, y: 210, r: 45 },
  { x: 55, y: 251, r: 30 },
  { x: 117, y: 270, r: 0 },
  { x: 182, y: 241, r: -40 },
  { x: 213, y: 200, r: -50 }
],

6: [
  { x: -13, y: 157, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 }
],

7: [
  { x: -13, y: 157, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 55, y: 251, r: 30 },
  { x: 117, y: 270, r: 0 },
  { x: 182, y: 241, r: -40 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 }
],

8: [
  { x: -29, y: 112, r: 70 },
  { x: -13, y: 159, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 },
  { x: 258, y: 107, r: -70 }
],

9: [
  { x: -29, y: 112, r: 70 },
  { x: -13, y: 159, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 117, y: 270, r: 0 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 },
  { x: 258, y: 107, r: -70 }
],

10: [
  { x: -37, y: 60, r: 90 },
  { x: -28, y: 107, r: 70 },
  { x: -13, y: 159, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 },
  { x: 258, y: 107, r: -70 },
  { x: 265, y: 58, r: -90 }
],

11: [
  { x: -35, y: 60, r: 90 },
  { x: -28, y: 107, r: 70 },
  { x: -13, y: 159, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 117, y: 270, r: 0 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 },
  { x: 258, y: 107, r: -70 },
  { x: 265, y: 58, r: -90 }
],

12: [
  { x: -29, y: -5, r: 120 },
  { x: -40, y: 52, r: 100 },
  { x: -28, y: 107, r: 70 },
  { x: -13, y: 159, r: 60 },
  { x: 17, y: 210, r: 45 },
  { x: 66, y: 253, r: 15 },
  { x: 163, y: 249, r: -15 },
  { x: 213, y: 200, r: -50 },
  { x: 239, y: 155, r: -60 },
  { x: 258, y: 107, r: -70 },
  { x: 265, y: 52, r: -100 },
  { x: 259, y: -5, r: -120 }
]
};
window.LPMPreviewProfiles["collier-cordon-pendentif"] = {
  desktop: collierCordonPendentifDesktopSlots,
  mobile: collierCordonPendentifMobileSlots,
  charmWidthDesktop: 155,
  charmWidthMobile: 100,
  mobileBreakpoint: 749,
  previewCountMap: {
    0: 0,
    1: 2,
    2: 2,
    3: 4,
    4: 4,
    5: 6,
    6: 6,
    7: 8,
    8: 8,
    9: 10,
    10: 10,
    11: 12,
    12: 12
  }
};
})();